import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.inspection-participant-section {
  display: flex;
  flex-direction: column;
  gap: ${dt('inspectionParticipantSection.gap')};
}

.inspection-participant-section .participant-section-grid {
  min-width: ${dt('inspectionParticipantSection.tableMinWidth')};
}

.inspection-participant-section .section-title {
  font-size: ${dt('inspectionParticipantSection.sectionTitle.fontSize')};
  font-weight: ${dt('inspectionParticipantSection.sectionTitle.fontWeight')};
  line-height: ${dt('inspectionParticipantSection.sectionTitle.lineHeight')};
  color: ${dt('inspectionParticipantSection.sectionTitle.color')};
}

.inspection-participant-section .section-subtitle {
  font-size: ${dt('inspectionParticipantSection.sectionSubtitle.fontSize')};
  font-weight: ${dt('inspectionParticipantSection.sectionSubtitle.fontWeight')};
  line-height: ${dt('inspectionParticipantSection.sectionSubtitle.lineHeight')};
  color: ${dt('inspectionParticipantSection.sectionSubtitle.color')};
}

.inspection-participant-section .section-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.inspection-participant-section .participant-table-wrap {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
}

.inspection-participant-section .participant-table-header-row {
  display: grid;
  grid-template-columns: 3rem repeat(4, minmax(0, 1fr)) 208px 3.25rem;
  column-gap: 1rem;
  row-gap: 0;
  align-items: center;
  padding: 0.75rem;
  min-width: ${dt('inspectionParticipantSection.tableMinWidth')};
}

.inspection-participant-section .participant-table-row {
  display: grid;
  grid-template-columns: 3rem repeat(4, minmax(0, 1fr)) 208px 3.25rem;
  column-gap: 1rem;
  row-gap: 0;
  align-items: center;
  padding: 0.75rem;
  min-width: ${dt('inspectionParticipantSection.tableMinWidth')};
}

.inspection-participant-section .participant-table-header-row > *,
.inspection-participant-section .participant-table-row > * {
  min-width: 0;
}

.inspection-participant-section .cell-number-width {
  box-sizing: border-box;
}

.inspection-participant-section .participant-table-header-cell {
  font-size: ${dt('inspectionParticipantSection.tableHeader.fontSize')};
  line-height: ${dt('inspectionParticipantSection.tableHeader.lineHeight')};
  color: ${dt('inspectionParticipantSection.tableHeader.color')};
}

.inspection-participant-section .participant-table-header-row > .participant-table-header-cell:nth-child(6) {
  padding: ${dt('inspectionParticipantSection.signatureCell.padding')};
  box-sizing: border-box;
}

.inspection-participant-section .row-border {
  border-bottom: 1px solid ${dt('inspectionParticipantSection.rowBorder.borderColor')};
}

.inspection-participant-section .empty-section-rule {
  align-self: stretch;
  border-bottom: 1px solid ${dt('inspectionParticipantSection.emptyRule.borderColor')};
}

.inspection-participant-section .cell {
  font-size: ${dt('inspectionParticipantSection.cell.fontSize')};
  line-height: ${dt('inspectionParticipantSection.cell.lineHeight')};
  color: ${dt('inspectionParticipantSection.cell.color')};
}

.inspection-participant-section .cell-number {
  justify-self: end;
  text-align: end;
  font-weight: ${dt('inspectionParticipantSection.cellNumber.fontWeight')};
  font-size: ${dt('inspectionParticipantSection.cellNumber.fontSize')};
  line-height: ${dt('inspectionParticipantSection.cellNumber.lineHeight')};
  color: ${dt('inspectionParticipantSection.cellNumber.color')};
}

.inspection-participant-section .signature-cell {
  display: flex;
  align-items: center;
  background: ${dt('inspectionParticipantSection.signatureCell.background')};
  font-size: ${dt('inspectionParticipantSection.signatureCell.fontSize')};
  line-height: ${dt('inspectionParticipantSection.signatureCell.lineHeight')};
  color: ${dt('inspectionParticipantSection.signatureCell.color')};
  padding: ${dt('inspectionParticipantSection.signatureCell.padding')};
  border-radius: ${dt('inspectionParticipantSection.signatureCell.borderRadius')};
  min-height: ${dt('inspectionParticipantSection.signatureCell.minHeight')};
}

.inspection-participant-section .signature-cell .participant-signature-thumb {
  max-height: 40px;
  max-width: 120px;
  object-fit: contain;
  display: block;
}

.inspection-participant-section .signature-cell .participant-refusal-label {
  color: ${dt('inspectionParticipantSection.signatureCell.refusalLabel.color')};
  font-size: 14px;
  line-height: 24px;
}

.inspection-participant-section .add-link-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.inspection-participant-section .add-link {
  display: ${dt('inspectionParticipantSection.addLink.display')};
  align-items: ${dt('inspectionParticipantSection.addLink.alignItems')};
  gap: ${dt('inspectionParticipantSection.addLink.gap')};
  padding: ${dt('inspectionParticipantSection.addLink.padding')};
  font-size: ${dt('inspectionParticipantSection.addLink.fontSize')};
  line-height: ${dt('inspectionParticipantSection.addLink.lineHeight')};
  font-weight: ${dt('inspectionParticipantSection.addLink.fontWeight')};
  color: ${dt('inspectionParticipantSection.addLink.color')};
  background: none;
  border: none;
  cursor: pointer;
}

.inspection-participant-section .add-link:hover {
  color: ${dt('inspectionParticipantSection.addLink.hoverColor')};
}

.inspection-participant-section .add-link:focus {
  outline: none;
}

.inspection-participant-section .row-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
}

.inspection-participant-section .row-actions .p-button-sm.p-button-icon-only {
  width: ${dt('button.icon.only.width')};
}`;
